import { createContext, useContext } from 'react';

// Provided by ShipmentsGuard to every page of the module once the verification is done:
// { status, ping, lock, locking, lockError }
export const GuardContext = createContext(null);

export function useGuard() {
  const value = useContext(GuardContext);
  if (!value) throw new Error('useGuard must be used inside ShipmentsGuard');
  return value;
}
